<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Data Export</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              name="inventorySearch"
              outlined
              dense
              label="Search"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <!-- excel icon -->
            <download-excel :data="inventory" :fields="fields" name="Products">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
            <!-- start of table -->
            <v-data-table
              :loading="loader"
              loading-text="Loading Data......"
              :headers="headers"
              :items="inventory"
              :search="search"
              :mobile-breakpoint="0"
            >
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      search: null,
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product Name", value: "Product" },
        { text: "Quantity", value: "Quantity" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Selling Price", value: "SellingPrice" },
      ],
      inventory: [],
      fields: {
        Product: "Product",
        Quantity: "Quantity",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "SellingPrice",
      },
    };
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDamageModal(item) {
      this.damagedItem = Object.assign({}, item);
      this.damageDialog = true;
    },
    openTransferModal(item) {
      this.transferItem = Object.assign({}, item);
      this.transferDialog = true;
    },
    inventoryInit() {
      const id = this.activeStore;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", `/stores/products/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.inventory = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.inventoryInit()]);
  },
};
</script>

<style lang="scss" scoped>
</style>